// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
import { useUser } from 'src/backoffice-app-code/features/Auth/applications/hooks/useUser';
import { UserRoleLabels } from 'src/backoffice-app-code/features/Auth/models/User';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { user, navigateToProfile } = useUser();

  return (
    <Link
      underline="none"
      color="inherit"
      onClick={navigateToProfile}
      sx={{
        cursor: 'pointer',
      }}
    >
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
          '&:hover': {
            opacity: 0.48,
          },
        }}
      >
        <Avatar src="/assets/avatar_12.jpg" alt={user?.id} />

        {!isCollapse && (
          <Box
            sx={{
              ml: 2,
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.shorter,
                }),
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 'calc(65%)',
              }}
            >
              {user?.email}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {user?.userRole ? UserRoleLabels[user?.userRole] : 'Unknown'}
            </Typography>
          </Box>
        )}
      </RootStyle>
    </Link>
  );
}
